import { ISheetTableCell } from '@common/interfaces/sheets'
import Base from './base'

export default class Sheets extends Base {
  exportTable(data: { title: string; rows: ISheetTableCell[][] }) {
    return this.apiClient.post('sheets/tables', data)
  }
}
